<template>
	<div>
		<component :is="this.$store.state.auth.role" ></component>
	</div>
</template>

<script>
import Client from '../components/profile/Client'
import Author from '../components/profile/Author'
import Manager from '../components/profile/Manager'
import Admin from '../components/profile/Admin'
import Partner from '../components/profile/Partner'
import Supervisor from '../components/profile/Supervisor'

export default {
	name: "Profile",
	components: {
		Client,
		Author,
		Manager,
		Admin,
		Partner,
		Supervisor,
	}
}
</script>

<style scoped>

</style>
